/**
 * System Message Types Collection.
 *
 * Contains a static list of available system message types, which can be used for different
 * purposes, like filling lists, allowing options selection, etc.
 *
 * @type {SystemMessageType[]} SystemMessageTypes
 */
export default [
  {
    key: 'system_resolved',
    value: 'Request resolved',
    icon: 'check-circle',
    color: 'success.700',
    backgroundColor: 'success.50',
  },
  {
    key: 'system_expired',
    value: 'Request expired',
    icon: 'clock',
    color: 'gray.700',
    backgroundColor: 'gray.950',
  },
  {
    key: 'system_cancelled',
    value: 'Request cancelled',
    icon: 'close-circle',
    color: 'error.700',
    backgroundColor: 'error.50',
  },
  {
    key: 'system_reopened',
    value: 'Request reopened',
    icon: 'replay',
    color: 'pending.700',
    backgroundColor: 'pending.50',
  },
  {
    key: 'system_yanked',
    value: 'Request yanked',
    icon: 'arrow-circle-up-right',
    color: 'pending.700',
    backgroundColor: 'pending.50',
  },
  {
    key: 'system_sorry_closed',
    value: 'Sorry, the request has been terminally closed and cannot be reopened. In case of need, submit a new request.',
    icon: 'face-frown',
    color: 'warning.700',
    backgroundColor: 'warning.50',
  },
  {
    key: 'system_close_delegate',
    value: 'Request has been transferred to another system and will be closed here. We\'ll reach out to you.',
    icon: 'repeat',
    color: 'black.light',
    backgroundColor: 'gray.950',
  },
]
